import { Component, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as fromRoot from '@app/reducers';
import { Group } from '@app/shared/models/group';
import { User } from '@app/shared/models/user';
import { DialogRef } from '@ngneat/dialog';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import * as fromMembers from '../../reducers/members.reducer';
import { MembersActions } from '../../actions';
@Component({
  selector: 'app-modal-attach-group',
  templateUrl: './modal-attach-group.component.html',
  styleUrls: ['./modal-attach-group.component.scss']
})
export class ModalAttachGroupComponent implements OnDestroy {

  memberToAttach: User;
  attributableGroups: any[];
  teamId: string;

  attachGroupSuccess$: Observable<boolean>;
  attachGroupProcessing$: Observable<boolean>;

  subscriptions: Subscription[] = [];
  attachGroupForm: FormGroup;
  submitted = false;
  selectedGroup: Group;

  constructor(private store$: Store<fromRoot.State & fromMembers.State>, private fb: FormBuilder, public ref: DialogRef) {
    this.memberToAttach = this.ref.data.memberToAttach;
    this.attributableGroups = this.ref.data.attributableGroups;
    this.teamId = this.ref.data.teamId;

    this.attachGroupProcessing$ = this.store$.select(fromMembers.getMemberAttachGroupProcessing);
    this.attachGroupSuccess$ = this.store$.select(fromMembers.getMemberAttachGroupSuccess);

    this.initForm();
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => {
      sub.unsubscribe();
    });
  }

  get f() { return this.attachGroupForm.controls; }

  initForm() {
    this.attachGroupForm = this.fb.group({
      group: ['', Validators.required],
    });
  }

  closeModal() {
    this.attachGroupForm.reset();
    this.ref.close();
  }

  attachMemberToGroup(member: User, group: string) {
    this.store$.dispatch(MembersActions.attachMemberToGroup({ teamId: this.teamId, member, group }));
    this.subscriptions.push(
      this.attachGroupSuccess$.subscribe(res => {
        if (res) {
          this.store$.dispatch(MembersActions.loadMember({ teamId: this.teamId, userId: member.id }));
          this.store$.dispatch(MembersActions.loadMemberRoles({ teamId: this.teamId, userId: member.id }));
          this.selectedGroup = null;
          this.attachGroupForm.reset();
          this.closeModal();
        }
      })
    );
  }

  onSubmit() {
    this.submitted = true;
    if (this.attachGroupForm.valid) {
      this.attachMemberToGroup(this.memberToAttach, this.attachGroupForm.value.group);
    }
  }
}
